/**
 * Do not edit directly
 * Generated on Mon, 04 Mar 2024 14:43:15 GMT
 */ const ColorBlack800 = "rgb(0 0 0 / 90%)"; // primary text color
const ColorBlack900 = "#000000";
const ColorEmerald100 = "#e3f2f6"; // Blue light
const ColorEmerald700 = "#0a806b"; // discount color | accent green
const ColorGreen100 = "#e7f3f0"; // Green light
const ColorGreen700 = "#318643"; // Green medium
const ColorGrey100 = "#f8f8f8"; // Grey light
const ColorGrey200 = "#efefef"; // Platinum
const ColorGrey300 = "#dfdfdf"; // Grey medium. Also, core brand palette
const ColorGrey400 = "#c4c4c4"; // Grey agreeable. Also, core brand palette
const ColorGrey500 = "#9e9e9e"; // New
const ColorGrey600 = "#707070"; // New
const ColorGrey700 = "#5c5c5c"; // Grey dark
const ColorGrey800 = "#313131"; // Graphite
const ColorGrey900 = "#151515"; // Charcoal
const ColorRed100 = "#fff0f0"; // Pink light
const ColorRed400 = "#f27373"; // Error color in dark mode
const ColorRed700 = "#d24345"; // Error color
const ColorWhite900 = "#ffffff";
const ColorYellow100 = "#faf1d7"; // Yellow light
const ColorYellow700 = "#e8b738"; // Yellow medium
const ColorLegacyAccentBlue = "#0099e0"; // Deprecated but maintained for backward compatibility
const ColorLegacyAccentGreen = "#0a806b"; // Deprecated but maintained for backward compatibility
const ColorLegacyAtlantic = "#16618c";
const ColorLegacyBlack = "#000000"; // Use for Text, Icons, Buttons, Links, Alerts, Background
const ColorLegacyBrandBlue = "#0075c2"; // Deprecated but maintained for backward compatibility
const ColorLegacyBrightBlue = "#2ba8e0"; // Deprecated Brand color
const ColorLegacyBubblegum = "#fa99cc"; // Deprecated Brand color
const ColorLegacyButtercup = "#ffc200"; // Deprecated Brand color
const ColorLegacyCandyApple = "#e00808"; // Deprecated but maintained for backward compatibility
const ColorLegacyCarbon = "#919699"; // Deprecated but maintained for backward compatibility
const ColorLegacyCaspian = "#204949";
const ColorLegacyCeltic = "#046240";
const ColorLegacyCharcoal = "#151515"; // Use for Text, Buttons, Alerts
const ColorLegacyDarkBlue = "#004471"; // Deprecated but maintained for backward compatibility
const ColorLegacyDarkGray = "#666666";
const ColorLegacyDarkGrey = "#666666"; // Use for Tiles
const ColorLegacyDeepBlue = "#006196"; // Deprecated Brand color
const ColorLegacyDolphin = "#666666"; // Deprecated but maintained for backward compatibility
const ColorLegacyEmerald = "#0a806b"; // Use for Badges text, Callout text, Promocode text
const ColorLegacyFireOrange = "#ff4f00"; // Deprecated Brand color
const ColorLegacyGrape = "#6e0a96"; // Deprecated Brand color
const ColorLegacyGraphite = "#313131";
const ColorLegacyGrass = "#66db2b"; // Deprecated Brand color
const ColorLegacyGreen = "#0a806b"; // Deprecated but maintained for backward compatibility
const ColorLegacyIris = "#6655d1";
const ColorLegacyKingfisher = "#017eb4";
const ColorLegacyLightBlue = "#e3f2f6"; // Use for Promo bar
const ColorLegacyLightGray = "#f8f8f8";
const ColorLegacyLightGreen = "#e7f3f0"; // Use for Promocode container
const ColorLegacyLightGrey = "#f8f8f8"; // Use for Tiles
const ColorLegacyLightPink = "#fff0f0"; // Use for Warning/Error Notification
const ColorLegacyLightYellow = "#faf1d7";
const ColorLegacyMandarin = "#b3351a";
const ColorLegacyMargarita = "#bff21c"; // Deprecated Brand color
const ColorLegacyMediumGray = "#dfdfdf";
const ColorLegacyMediumGreen = "#318643"; // Use for Confirmation message text, Confirmation alert
const ColorLegacyMediumGrey = "#dfdfdf"; // Use for Text, Buttons, Alerts
const ColorLegacyMediumYellow = "#e8b738"; // Use for Caution Studio
const ColorLegacyMidnight = "#38454f"; // Deprecated but maintained for backward compatibility
const ColorLegacyMist = "#f8f8f8"; // Deprecated but maintained for backward compatibility
const ColorLegacyOceanBlue = "#44a2dd";
const ColorLegacyOpal = "#c0e6df";
const ColorLegacyOrange = "#ff8200"; // Deprecated but maintained for backward compatibility
const ColorLegacyPink = "#e10096"; // Deprecated but maintained for backward compatibility
const ColorLegacyPlatinum = "#efefef";
const ColorLegacyPumpkin = "#ba5d10";
const ColorLegacyRed = "#f24345"; // Use for Error message text, Error alert
const ColorLegacyRio = "#99d3f3";
const ColorLegacyRuby = "#e10096"; // Deprecated but maintained for backward compatibility
const ColorLegacyRum = "#c94b2f";
const ColorLegacySantorini = "#3b5ff3"; // Use for Help/Support
const ColorLegacyScarlet = "#9a0202"; // Use for Holiday only
const ColorLegacySilver = "#c8cbcc"; // Deprecated but maintained for backward compatibility
const ColorLegacySkyBlue = "#73d2f2";
const ColorLegacyTalavera = "#2b3b55";
const ColorLegacyUltramarine = "#3e3cbc"; // Use for Help/Support
const ColorLegacyUltraviolet = "#ad00b0"; // Deprecated Brand color
const ColorLegacyViolet = "#844cbc";
const ColorLegacyWarning = "#ba5d10"; // Deprecated but maintained for backward compatibility. Use status.warning instead, since that supports dark mode
const ColorLegacyWhite = "#ffffff"; // Use for Text (on dark bg), Buttons (dark mode)
const ColorSemanticDiscount = "#0a806b";
const ColorSemanticDiscountBackground = "#e7f3f0";
const ColorSemanticFocus = "#017eb4";
const ColorSemanticFocusDark = "#99d3f3";
const ColorSemanticHoliday = "#9a0202";
const ColorSemanticHolidayBeige1 = "#ede3cf";
const ColorSemanticHolidayGreen1 = "#318750";
const ColorSemanticHolidayGreen2 = "#06462E";
const ColorSemanticHolidayRed1 = "#A5030B";
const ColorSemanticHolidayRed2 = "#A5030B";
const ColorExternalSelectedDesignExperience = "#3894f2"; // Used by studio team
const FontFamilyGraphik = "'Graphik', 'sans-serif'";
const FontFamilyPrimary = "'Graphik', 'sans-serif'";
const FontFamilySecondary = "'Graphik', 'sans-serif'";
const FontFamilySpecial = "'Tiempos', georgia, times, serif";
const FontWeightNormal = 400;
const FontWeightBold = 700;
const FontWeightBolder = 900;
const FontSize1 = "0.778rem";
const FontSize2 = "0.889rem";
const FontSize3 = "1rem";
const FontSize4 = "1.111rem";
const FontSize5 = "1.667rem";
const FontSize6 = "2.111rem";
const FontSizeM2 = "0.667rem";
const FontSizeM1 = "0.667rem";
const FontSizeXm2Xs = "0.667rem";
const FontSizeXm2Md = "0.722rem";
const FontSizeXm2Auto = "0.667rem";
const FontSizeXm1Xs = "0.778rem";
const FontSizeXm1Md = "0.889rem";
const FontSizeXm1Auto = "0.778rem";
const FontSizeXXs = "0.889rem";
const FontSizeXMd = "1rem";
const FontSizeXAuto = "0.889rem";
const FontSizeX1Xs = "1.111rem";
const FontSizeX1Md = "1.333rem";
const FontSizeX1Auto = "1.111rem";
const FontSizeX2Xs = "1.389rem";
const FontSizeX2Md = "1.778rem";
const FontSizeX2Auto = "1.389rem";
const FontSizeX3Xs = "1.722rem";
const FontSizeX3Md = "2.389rem";
const FontSizeX3Auto = "1.722rem";
const FontSizeX4Xs = "2.167rem";
const FontSizeX4Md = "3.167rem";
const FontSizeX4Auto = "2.167rem";
const FontSizeX5Xs = "2.667rem";
const FontSizeX5Md = "4.22rem";
const FontSizeX5Auto = "2.667rem";
const FontSizeX6Xs = "3.389rem";
const FontSizeX6Md = "5.56rem";
const FontSizeX6Auto = "3.389rem";
const FontLineHeight1 = "1.5";
const FontLineHeight2 = "1.5";
const FontLineHeight3 = "1.5";
const FontLineHeight4 = "1.2";
const FontLineHeight5 = "1";
const FontLineHeight6 = "1";
const FontLineHeightM1 = "1.5";
const FontLineHeightM2 = "1.5";
const FontLineHeightX6 = "1.1";
const FontLineHeightX5 = "1.1";
const FontLineHeightX4 = "1.2";
const FontLineHeightX3 = "1.2";
const FontLineHeightX2 = "1.2";
const FontLineHeightX1 = "1.2";
const FontLineHeightX = "1.5";
const FontLineHeightXm1 = "1.5";
const FontLineHeightXm2 = "1.5";
const FontLetterSpacing1 = "-0.01em";
const FontLetterSpacing2 = "-0.01em";
const FontLetterSpacing3 = "-0.01em";
const FontLetterSpacing4 = "-0.01em";
const FontLetterSpacing5 = "-0.01em";
const FontLetterSpacing6 = "-0.02em";
const FontLetterSpacingM1 = "-0.01em";
const FontLetterSpacingM2 = "-0.01em";
const FontLetterSpacingX6 = "-0.01em";
const FontLetterSpacingX5 = "-0.01em";
const FontLetterSpacingX4 = "-0.01em";
const FontLetterSpacingX3 = "-0.01em";
const FontLetterSpacingX2 = "-0.01em";
const FontLetterSpacingX1 = "-0.01em";
const FontLetterSpacingX = "0.005em";
const FontLetterSpacingXm1 = "0.005em";
const FontLetterSpacingXm2 = "0.005em";
const ShadowDepth1 = "0 1px 4px rgb(0 10 17 / 10%)";
const ShadowDepth2 = "0 2px 8px rgb(0 17 26 / 10%)";
const SizeStandard0 = 0;
const SizeStandard1 = "4px";
const SizeStandard2 = "8px";
const SizeStandard3 = "12px";
const SizeStandard4 = "16px";
const SizeStandard5 = "24px";
const SizeStandard6 = "32px";
const SizeStandard7 = "40px";
const SizeStandard8 = "48px";
const SizeStandard9 = "64px";
const SizeStandard10 = "80px";
const SizeStandard11 = "96px";
const SizeStandard12 = "128px";
const SizeStandard13 = "160px";
const SizeBreakpointXsStart = 0;
const SizeBreakpointXsEnd = "767px";
const SizeBreakpointSmStart = "768px";
const SizeBreakpointSmEnd = "1023px";
const SizeBreakpointMdStart = "1024px";
const SizeBreakpointMdEnd = "1439px";
const SizeBreakpointLgStart = "1440px";
const SizeBreakpointLgEnd = "1919px";
const SizeBreakpointXlStart = "1920px";
const BaseBackgroundColor = "#ffffff";
const BaseTextWeight = 400;
const BaseTextColor = "rgb(0 0 0 / 90%)";
const BaseBorderColor = "#dfdfdf";
const ElementsLinkFontColorStandard = "inherit";
const ElementsLinkFontColorHover = "#5c5c5c";
const ElementsLinkTextDecorationStandard = "underline";
const ElementsLinkTextDecorationHover = "underline";
const ElementsStandardTileBottomGutter = "64px";
const ElementsStandardTileBottomGutterXs = "40px";
const ElementsCardFontColor = "inherit";
const ElementsCardEvenHeightMarginBottom = "32px";
const ElementsCardPaddingStandard = "16px";
const ElementsCheckboxRadioBackground = "#ffffff";
const ElementsCheckboxRadioBackgroundDisabled = "rgba(223 223 223 / 50%)";
const ElementsCheckboxRadioWidth = "20px";
const ElementsCheckboxRadioBorderRadius = "4px";
const ElementsCheckboxRadioTransition = "opacity 0.2s ease";
const ElementsCheckboxRadioCheckedOpacityHover = "0.6";
const ElementsCheckboxRadioCheckedBackground = "#000000";
const ElementsCheckboxRadioBorderColorStandard = "#5c5c5c";
const ElementsCheckboxRadioBorderColorHover = "#5c5c5c";
const ElementsCheckboxRadioBorderColorChecked = "#000000";
const ElementsCheckboxRadioBorderColorDisabled = "#f8f8f8";
const ElementsCheckboxRadioBorderWidthStandard = "1.5px";
const ElementsCheckboxRadioBorderWidthHover = "1.5px";
const ElementsCheckboxRadioBorderWidthChecked = "1.5px";
const ElementsCheckboxRadioWidthFavorite = "44px";
const ElementsInputColorPlaceholder = "inherit";
const ElementsInputOpacityPlaceholder = "0.5";
const ElementsInputHeight = "60px";
const ElementsInputFontSize = "0.889rem";
const ElementsInputFontSizeMini = "0.778rem";
const ElementsInputBorderWidth = "1px";
const ElementsInputBorderColor = "#707070";
const ElementsInputBorderColorFocus = "#000000";
const ElementsInputBorderColorValue = "#707070";
const ElementsInputBorderRadius = "8px";
const ElementsInputOutlineWidthFocus = "2px";
const ElementsInputOutlineColorFocus = "#000000";
const ElementsInputFloatingLabelFontColor = "#5c5c5c";
const ElementsInputFloatingLabelFontLineHeight = "1.5";
const ElementsInputFloatingLabelFontSizeFocus = "0.667rem";
const ElementsInputFloatingLabelFontWeightFocus = "normal";
const ElementsInputFloatingLabelPaddingTop = ".75em";
const ElementsInputFloatingLabelTopFocus = "7px";
const ElementsInputFloatingLabelTopMiniFocus = "1px";
const ElementsInputPaddingHorizontal = "12px";
const ElementsLauncherBackgroundColor = "#ffffff";
const ElementsLauncherBorderColor = "#707070";
const ElementsLauncherBorderColorFocus = "#000000";
const ElementsLauncherBorderWidth = "1px";
const ElementsLauncherBorderRadius = "8px";
const ElementsLauncherFontColor = "rgb(0 0 0 / 90%)";
const ElementsLauncherFontSize = "0.889rem";
const ElementsLauncherFontSizeMini = "0.778rem";
const ElementsLauncherHeightStandard = "60px";
const ElementsLauncherHeightMini = "40px";
const ElementsLauncherOutlineWidthFocus = "2px";
const ElementsLauncherOutlineColorFocus = "#000000";
const ElementsButtonFontSizeStandard = "0.778rem";
const ElementsButtonHeightMini = "40px";
const ElementsModalDialogBackdropZIndex = "10000";
const ElementsBoundedContentPadding = "0 calc(48px - 8px)";
const ElementsBoundedContentPaddingHorizontal = "calc(48px - 8px)";
const IconFilterBrandBlue = "invert(29%) sepia(94%) saturate(1310%) hue-rotate(181deg) brightness(96%) contrast(99%);";
const IconFilterBlueDark = "invert(20%) sepia(31%) saturate(1983%) hue-rotate(172deg) brightness(100%) contrast(101%);";
const IconFilterStandard = "saturate(0%) brightness(0%)";
const IconFilterWhite = "saturate(0%) brightness(0%) invert(100%)";
const IconFilterBlack = "saturate(0%) brightness(0%)";
const IconFilterGreyDark = "invert(50%) sepia(62%) saturate(0%) hue-rotate(246deg) brightness(76%) contrast(83%);";
const IconFilterGreyMedium = "invert(98%) sepia(10%) saturate(88%) hue-rotate(294deg) brightness(111%) contrast(84%);";
const IconFilterGrey500 = "invert(98%) sepia(10%) saturate(38%) hue-rotate(294deg) brightness(96%) contrast(24%)";
const IconFilterGrey300 = "invert(98%) sepia(10%) saturate(38%) hue-rotate(294deg) brightness(100%) contrast(94%)";
const IconFilterError = "invert(43%) sepia(84%) saturate(1275%) hue-rotate(325deg) brightness(80%) contrast(108%)";
const IconHeightStandard = "20px";
const IconHeightSuper = "28px";
const IconWidthStandard = "20px";
const IconWidthSuper = "28px";
const SpacingStandard0 = 0;
const SpacingStandard1 = "4px";
const SpacingStandard2 = "8px";
const SpacingStandard3 = "12px";
const SpacingStandard4 = "16px";
const SpacingStandard5 = "24px";
const SpacingStandard6 = "32px";
const SpacingStandard7 = "40px";
const SpacingStandard8 = "48px";
const SpacingStandard9 = "64px";
const SpacingStandard10 = "80px";
const SpacingStandard11 = "96px";
const SpacingStandard12 = "128px";
const SpacingStandard13 = "160px";
const SpacingLayoutGridGutterStandard = "8px";
const SpacingLayoutGridGutterTight = "calc(4px / 2)";
const SpacingLayoutGridTopLevelMaxWidth = "min(1920px - (2 * calc(48px - 8px)), (100vw - (2 * calc(48px - 8px))))";
const SpacingLayoutPageContentMaxWidth = "1920px";
const SpacingLayoutGlobalHeroMaxWidth = "1920px";
const StateSelectedBorderColor = "#000000";
const StateSelectedBackgroundColor = "#000000";
const StateDisabledBackground = "rgb(223 223 223 / 50%)";
const StateDisabledBorder = "#efefef";
const StateDisabledFont = "#5c5c5c";
const StatusError = "#d24345";
const StatusWarning = "#ba5d10";

export { BaseBackgroundColor, BaseBorderColor, BaseTextColor, BaseTextWeight, ColorBlack800, ColorBlack900, ColorEmerald100, ColorEmerald700, ColorExternalSelectedDesignExperience, ColorGreen100, ColorGreen700, ColorGrey100, ColorGrey200, ColorGrey300, ColorGrey400, ColorGrey500, ColorGrey600, ColorGrey700, ColorGrey800, ColorGrey900, ColorLegacyAccentBlue, ColorLegacyAccentGreen, ColorLegacyAtlantic, ColorLegacyBlack, ColorLegacyBrandBlue, ColorLegacyBrightBlue, ColorLegacyBubblegum, ColorLegacyButtercup, ColorLegacyCandyApple, ColorLegacyCarbon, ColorLegacyCaspian, ColorLegacyCeltic, ColorLegacyCharcoal, ColorLegacyDarkBlue, ColorLegacyDarkGray, ColorLegacyDarkGrey, ColorLegacyDeepBlue, ColorLegacyDolphin, ColorLegacyEmerald, ColorLegacyFireOrange, ColorLegacyGrape, ColorLegacyGraphite, ColorLegacyGrass, ColorLegacyGreen, ColorLegacyIris, ColorLegacyKingfisher, ColorLegacyLightBlue, ColorLegacyLightGray, ColorLegacyLightGreen, ColorLegacyLightGrey, ColorLegacyLightPink, ColorLegacyLightYellow, ColorLegacyMandarin, ColorLegacyMargarita, ColorLegacyMediumGray, ColorLegacyMediumGreen, ColorLegacyMediumGrey, ColorLegacyMediumYellow, ColorLegacyMidnight, ColorLegacyMist, ColorLegacyOceanBlue, ColorLegacyOpal, ColorLegacyOrange, ColorLegacyPink, ColorLegacyPlatinum, ColorLegacyPumpkin, ColorLegacyRed, ColorLegacyRio, ColorLegacyRuby, ColorLegacyRum, ColorLegacySantorini, ColorLegacyScarlet, ColorLegacySilver, ColorLegacySkyBlue, ColorLegacyTalavera, ColorLegacyUltramarine, ColorLegacyUltraviolet, ColorLegacyViolet, ColorLegacyWarning, ColorLegacyWhite, ColorRed100, ColorRed400, ColorRed700, ColorSemanticDiscount, ColorSemanticDiscountBackground, ColorSemanticFocus, ColorSemanticFocusDark, ColorSemanticHoliday, ColorSemanticHolidayBeige1, ColorSemanticHolidayGreen1, ColorSemanticHolidayGreen2, ColorSemanticHolidayRed1, ColorSemanticHolidayRed2, ColorWhite900, ColorYellow100, ColorYellow700, ElementsBoundedContentPadding, ElementsBoundedContentPaddingHorizontal, ElementsButtonFontSizeStandard, ElementsButtonHeightMini, ElementsCardEvenHeightMarginBottom, ElementsCardFontColor, ElementsCardPaddingStandard, ElementsCheckboxRadioBackground, ElementsCheckboxRadioBackgroundDisabled, ElementsCheckboxRadioBorderColorChecked, ElementsCheckboxRadioBorderColorDisabled, ElementsCheckboxRadioBorderColorHover, ElementsCheckboxRadioBorderColorStandard, ElementsCheckboxRadioBorderRadius, ElementsCheckboxRadioBorderWidthChecked, ElementsCheckboxRadioBorderWidthHover, ElementsCheckboxRadioBorderWidthStandard, ElementsCheckboxRadioCheckedBackground, ElementsCheckboxRadioCheckedOpacityHover, ElementsCheckboxRadioTransition, ElementsCheckboxRadioWidth, ElementsCheckboxRadioWidthFavorite, ElementsInputBorderColor, ElementsInputBorderColorFocus, ElementsInputBorderColorValue, ElementsInputBorderRadius, ElementsInputBorderWidth, ElementsInputColorPlaceholder, ElementsInputFloatingLabelFontColor, ElementsInputFloatingLabelFontLineHeight, ElementsInputFloatingLabelFontSizeFocus, ElementsInputFloatingLabelFontWeightFocus, ElementsInputFloatingLabelPaddingTop, ElementsInputFloatingLabelTopFocus, ElementsInputFloatingLabelTopMiniFocus, ElementsInputFontSize, ElementsInputFontSizeMini, ElementsInputHeight, ElementsInputOpacityPlaceholder, ElementsInputOutlineColorFocus, ElementsInputOutlineWidthFocus, ElementsInputPaddingHorizontal, ElementsLauncherBackgroundColor, ElementsLauncherBorderColor, ElementsLauncherBorderColorFocus, ElementsLauncherBorderRadius, ElementsLauncherBorderWidth, ElementsLauncherFontColor, ElementsLauncherFontSize, ElementsLauncherFontSizeMini, ElementsLauncherHeightMini, ElementsLauncherHeightStandard, ElementsLauncherOutlineColorFocus, ElementsLauncherOutlineWidthFocus, ElementsLinkFontColorHover, ElementsLinkFontColorStandard, ElementsLinkTextDecorationHover, ElementsLinkTextDecorationStandard, ElementsModalDialogBackdropZIndex, ElementsStandardTileBottomGutter, ElementsStandardTileBottomGutterXs, FontFamilyGraphik, FontFamilyPrimary, FontFamilySecondary, FontFamilySpecial, FontLetterSpacing1, FontLetterSpacing2, FontLetterSpacing3, FontLetterSpacing4, FontLetterSpacing5, FontLetterSpacing6, FontLetterSpacingM1, FontLetterSpacingM2, FontLetterSpacingX, FontLetterSpacingX1, FontLetterSpacingX2, FontLetterSpacingX3, FontLetterSpacingX4, FontLetterSpacingX5, FontLetterSpacingX6, FontLetterSpacingXm1, FontLetterSpacingXm2, FontLineHeight1, FontLineHeight2, FontLineHeight3, FontLineHeight4, FontLineHeight5, FontLineHeight6, FontLineHeightM1, FontLineHeightM2, FontLineHeightX, FontLineHeightX1, FontLineHeightX2, FontLineHeightX3, FontLineHeightX4, FontLineHeightX5, FontLineHeightX6, FontLineHeightXm1, FontLineHeightXm2, FontSize1, FontSize2, FontSize3, FontSize4, FontSize5, FontSize6, FontSizeM1, FontSizeM2, FontSizeX1Auto, FontSizeX1Md, FontSizeX1Xs, FontSizeX2Auto, FontSizeX2Md, FontSizeX2Xs, FontSizeX3Auto, FontSizeX3Md, FontSizeX3Xs, FontSizeX4Auto, FontSizeX4Md, FontSizeX4Xs, FontSizeX5Auto, FontSizeX5Md, FontSizeX5Xs, FontSizeX6Auto, FontSizeX6Md, FontSizeX6Xs, FontSizeXAuto, FontSizeXMd, FontSizeXXs, FontSizeXm1Auto, FontSizeXm1Md, FontSizeXm1Xs, FontSizeXm2Auto, FontSizeXm2Md, FontSizeXm2Xs, FontWeightBold, FontWeightBolder, FontWeightNormal, IconFilterBlack, IconFilterBlueDark, IconFilterBrandBlue, IconFilterError, IconFilterGrey300, IconFilterGrey500, IconFilterGreyDark, IconFilterGreyMedium, IconFilterStandard, IconFilterWhite, IconHeightStandard, IconHeightSuper, IconWidthStandard, IconWidthSuper, ShadowDepth1, ShadowDepth2, SizeBreakpointLgEnd, SizeBreakpointLgStart, SizeBreakpointMdEnd, SizeBreakpointMdStart, SizeBreakpointSmEnd, SizeBreakpointSmStart, SizeBreakpointXlStart, SizeBreakpointXsEnd, SizeBreakpointXsStart, SizeStandard0, SizeStandard1, SizeStandard10, SizeStandard11, SizeStandard12, SizeStandard13, SizeStandard2, SizeStandard3, SizeStandard4, SizeStandard5, SizeStandard6, SizeStandard7, SizeStandard8, SizeStandard9, SpacingLayoutGlobalHeroMaxWidth, SpacingLayoutGridGutterStandard, SpacingLayoutGridGutterTight, SpacingLayoutGridTopLevelMaxWidth, SpacingLayoutPageContentMaxWidth, SpacingStandard0, SpacingStandard1, SpacingStandard10, SpacingStandard11, SpacingStandard12, SpacingStandard13, SpacingStandard2, SpacingStandard3, SpacingStandard4, SpacingStandard5, SpacingStandard6, SpacingStandard7, SpacingStandard8, SpacingStandard9, StateDisabledBackground, StateDisabledBorder, StateDisabledFont, StateSelectedBackgroundColor, StateSelectedBorderColor, StatusError, StatusWarning };
